import gql from 'graphql-tag'

export default gql`
    query AvailableStreets($zipcode: String!, $city: String!) {
        availableStreets(zipcode: $zipcode, city: $city)
    }
`
